import Contract from "slotworks/utils/contract";
import { sequence } from "slotworks/utils/race-utils";
import gameState from "slotworks/model/game-state";
import BonusRecord from "integration/revolver/schema/bonus-record";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request";
import commsManager from "slotworks/server/comms-manager";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";

export default class BonusComponent {

    public displayAward() {
        const bonusRecord = gameState.getCurrentGame().latestRecord() as BonusRecord;
        const contents = new Map<string, string>();
        contents.set("value", `${bonusRecord.retriggers}`);
        soundManager.customEvent("jp_extra_chances_award");
        return Components.prompt.show(["freespin_respin_award"], contents, 2000);
    }

    public sendBonusRequest() {
        const request = new PickRequestPayload();
        return commsManager.request(request);
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/respin/bonus-component.ts